export enum NivelAcesso {
  Administrador = 1,
  Nivel2 = 2,
  Nivel3 = 3,
  Nivel4 = 4
}
